"use client";

import { c as _c } from "react/compiler-runtime";
import { addChapterToChapterViews, addChapterToCompletions } from "@/actions/chapter";
import VideoPlayer from "@/components/fancy/video-player";
import { TChapter, TChapterStats } from "@/types/types";
import { getVideoUrl } from "@/utils/media-utils";
import { tryCatch } from "@/utils/validators";
import Link from "next/link";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
type ChapterPlayerProps = {
  chapter: TChapter;
  chapterStats: TChapterStats;
  nextChapterUrl?: string;
};
export default function ChapterPlayer(t0) {
  const $ = _c(24);
  const {
    chapter,
    chapterStats,
    nextChapterUrl
  } = t0;
  const [, setIsPlaying] = useState(false);
  const [isFirstPlay, setIsFirstPlay] = useState(true);
  const startTimeRef = useRef(null);
  const watchedTimeRef = useRef(0);
  const isCompletedRef = useRef(chapterStats.hasCompleted);
  const intervalRef = useRef(null);
  const router = useRouter();
  const hasUserEnrolled = chapterStats.hasEnrolled;
  const canWatchVideo = hasUserEnrolled || chapter.isFree;
  let t1;
  if ($[0] !== chapter.chapterVideo) {
    t1 = chapter.chapterVideo ? getVideoUrl(chapter.chapterVideo) : "";
    $[0] = chapter.chapterVideo;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const videoUrl = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
    t3 = [];
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  useEffect(t2, t3);
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = function getCurrentTime() {
      return Date.now();
    };
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const getCurrentTime = t4;
  let handleEnd;
  let handlePause;
  let handlePlay;
  if ($[5] !== chapter.chapterVideo?.duration || $[6] !== chapter.id || $[7] !== isFirstPlay || $[8] !== nextChapterUrl || $[9] !== router) {
    handlePlay = function handlePlay() {
      if (isFirstPlay) {
        handleChapterWatch();
        setIsFirstPlay(false);
      }
      startTimeRef.current = getCurrentTime();
      setIsPlaying(true);
      if (!intervalRef.current) {
        intervalRef.current = setInterval(() => {
          watchedTimeRef.current = watchedTimeRef.current + 1;
          const chapterDuration = chapter.chapterVideo?.duration;
          if (!isCompletedRef.current && chapterDuration && watchedTimeRef.current >= chapterDuration * 0.8) {
            handleChapterComplete();
            isCompletedRef.current = true;
          }
        }, 1000);
      }
    };
    let t5;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = function handlePause() {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        startTimeRef.current = null;
        setIsPlaying(false);
      };
      $[13] = t5;
    } else {
      t5 = $[13];
    }
    handlePause = t5;
    let t6;
    if ($[14] !== nextChapterUrl || $[15] !== router) {
      t6 = function handleEnd() {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
        startTimeRef.current = null;
        watchedTimeRef.current = 0;
        setIsPlaying(false);
        setIsFirstPlay(true);
        if (nextChapterUrl) {
          router.push(nextChapterUrl);
        }
      };
      $[14] = nextChapterUrl;
      $[15] = router;
      $[16] = t6;
    } else {
      t6 = $[16];
    }
    handleEnd = t6;
    async function handleChapterWatch() {
      const {
        error
      } = await tryCatch(addChapterToChapterViews(chapter.id));
      if (error) {
        toast.error(error.message);
        return;
      }
    }
    async function handleChapterComplete() {
      const {
        error: error_0
      } = await tryCatch(addChapterToCompletions(chapter.id));
      if (error_0) {
        toast.error(error_0.message);
        return;
      }
    }
    $[5] = chapter.chapterVideo?.duration;
    $[6] = chapter.id;
    $[7] = isFirstPlay;
    $[8] = nextChapterUrl;
    $[9] = router;
    $[10] = handleEnd;
    $[11] = handlePause;
    $[12] = handlePlay;
  } else {
    handleEnd = $[10];
    handlePause = $[11];
    handlePlay = $[12];
  }
  let t5;
  if ($[17] !== canWatchVideo || $[18] !== chapter.section || $[19] !== handleEnd || $[20] !== handlePause || $[21] !== handlePlay || $[22] !== videoUrl) {
    t5 = <div className="w-full"><div className="relative flex aspect-video w-full items-center justify-center overflow-hidden rounded-xl bg-black text-background shadow-lg">{canWatchVideo ? videoUrl ? <VideoPlayer autoPlay={true} videoUrl={videoUrl} handlePlayAction={handlePlay} handlePauseAction={handlePause} handleEndAction={handleEnd} /> : <p className="text-sm">No video added</p> : <div className="flex animate-pulse flex-col items-center gap-2 text-sm text-white md:flex-row lg:text-base"><p>Please enroll in the course to watch this chapter.</p><Link href={`/course/${chapter.section.course.slug}/enroll`} className="text-blue-600 underline underline-offset-2">Enroll here</Link></div>}</div></div>;
    $[17] = canWatchVideo;
    $[18] = chapter.section;
    $[19] = handleEnd;
    $[20] = handlePause;
    $[21] = handlePlay;
    $[22] = videoUrl;
    $[23] = t5;
  } else {
    t5 = $[23];
  }
  return t5;
}